module.exports = {"131124100":"饶阳镇","131124101":"大尹村镇","131124102":"五公镇","131124103":"大官亭镇","131124104":"王同岳镇","131124202":"留楚乡","131124203":"东里满乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131124.json
// module id = 248
// module chunks = 0